import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setDocumentCount } from "../../repository/slice";

function* getDocumentCountWorker(): SagaIterator {
  try {
    yield put(setLoading(true));
    const { data, message, isError }: IResponse<any> = yield call(
      requester.get,
      "/api/admin/document-comments/unread-count"
    );
    if (!isError) {
      yield put(setDocumentCount(data.count));
    } else {
      console.error(message);
    }
  } catch (error) {
    console.error("getDocumentCountWorker: ", error);
  } finally {
    yield put(setLoading(false));
  }
}

export function* getDocumentCountWatcher() {
  yield takeLatest("@saga/GET_DOCUMENT_COUNT", getDocumentCountWorker);
}
